import CropFreeIcon from '@mui/icons-material/CropFree';
import { Button } from '@mui/material';
import { type FC, useState } from 'react';

import CameraZoneEditor from './CameraZoneEditor.js';
import { type CameraZone } from '../../api/index.js';

interface Props {
  cameraId: string;
  cameraName: string;
  zones?: CameraZone[] | null;
}

const CameraZonesButton: FC<Props> = ({ cameraId, cameraName, zones }) => {
  const [open, setOpen] = useState(false);
  const count = zones?.length ?? 0;
  return (
    <>
      <Button
        size="small"
        variant="outlined"
        startIcon={<CropFreeIcon fontSize="small" />}
        onClick={() => setOpen(true)}
      >
        Zones{count > 0 ? ` (${count})` : ''}
      </Button>
      <CameraZoneEditor
        open={open}
        cameraId={cameraId}
        cameraName={cameraName}
        initialZones={zones}
        onClose={() => setOpen(false)}
      />
    </>
  );
};

export default CameraZonesButton;
